<template>
  <!-- Briefumschlag mit Glocke: Symbol für „E-Mail-Empfang & Benachrichtigungen"
       (Kundenfeedback 15.10.2026). Die Glocke sitzt als Plakette unten
       rechts auf dem Umschlag. -->
  <span aria-hidden="true" class="mail-bell" :style="{ '--mb-size': `${size}px` }">
    <Mail class="mail-bell__mail" :size="size" :stroke-width="strokeWidth" />
    <span class="mail-bell__badge">
      <Bell :size="Math.round(size * 0.48)" :stroke-width="2.4" />
    </span>
  </span>
</template>

<script setup lang="ts">
  import { Bell, Mail } from 'lucide-vue-next'

  withDefaults(defineProps<{ size?: number, strokeWidth?: number }>(), {
    size: 22,
    strokeWidth: 2,
  })
</script>

<style lang="scss" scoped>
.mail-bell {
  position: relative;
  display: inline-flex;
  width: var(--mb-size);
  height: var(--mb-size);
  flex-shrink: 0;
}
.mail-bell__badge {
  position: absolute;
  right: calc(var(--mb-size) * -0.28);
  bottom: calc(var(--mb-size) * -0.22);
  display: grid;
  place-items: center;
  width: calc(var(--mb-size) * 0.66);
  height: calc(var(--mb-size) * 0.66);
  border-radius: 50%;
  color: var(--mail-bell-badge-fg, #fff);
  background: var(--mail-bell-badge-bg, #f59e0b);
  box-shadow: 0 0 0 2px var(--mail-bell-ring, #fff);
}
</style>
